// extracted by mini-css-extract-plugin
export default {"section":"Experience_section__XLux5","card":"Experience_card__0LNgL","icon":"Experience_icon__b4yXy","goldLine":"Experience_goldLine__qjynf"};